
export default {
  data() {
    return {
      showSuccessMsg: false,

      options: [
        {
          name: "icon",
          label: this.$t("label.icon"),
          type: "image",
          size: "32x32",
        },
        {
          name: "title",
          label: this.$t("label.title"),
          type: "text",
        },
        {
          name: "info",
          label: this.$t("label.info"),
          type: "tipTap",
        },
      ],
    };
  },

  mounted() {
    if (
      this.$refs.contactForm &&
      this.$refs.contactForm.form &&
      this.$refs.contactForm.form.additionalFields
    ) {
      if (
        this.$route.query &&
        this.$route.query.productName &&
        this.$route.query.productSku &&
        this.$route.query.productSlug
      ) {
        this.$refs.contactForm.form.additionalFields.product = `\n ${this.$t(
          "text.productName"
        )}: ${this.$route.query.productName}, \n ${this.$t(
          "text.productSku"
        )}: ${this.$route.query.productSku}, \n ${this.$t(
          "text.productSlug"
        )}: ${this.$route.query.productSlug}`;
      } else
        this.$refs.contactForm.form.additionalFields.product = this.$t(
          "text.noProductSelecter"
        );
    }
  },
};
